/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var ReactDOM = require("react-dom");
var isDescendant = function (el, target) {
    if (target !== null) {
        return el === target || isDescendant(el, target.parentNode);
    }
    return false;
};
var outsideClickEvents = ["mouseup", "touchend"];
var bind = function (callback) {
    return outsideClickEvents.forEach(function (event) {
        return document.addEventListener(event, callback);
    });
};
var unbind = function (callback) {
    return outsideClickEvents.forEach(function (event) {
        return document.addEventListener(event, callback);
    });
};
var OutsideClick = /** @class */ (function (_super) {
    tslib_1.__extends(OutsideClick, _super);
    function OutsideClick(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClickAway = function (evt) {
            if (_this.isCurrentlyMounted) {
                var el = ReactDOM.findDOMNode(_this);
                if (document.documentElement &&
                    document.documentElement.contains(evt.target) &&
                    !isDescendant(el, evt.target)) {
                    _this.props.onOutsideClick(evt);
                }
            }
        };
        _this.isCurrentlyMounted = false;
        return _this;
    }
    OutsideClick.prototype.componentDidMount = function () {
        this.isCurrentlyMounted = true;
        if (this.props.onOutsideClick) {
            bind(this.handleClickAway);
        }
    };
    OutsideClick.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.onOutsideClick !== this.props.onOutsideClick) {
            unbind(this.handleClickAway);
            if (this.props.onOutsideClick) {
                bind(this.handleClickAway);
            }
        }
    };
    OutsideClick.prototype.componentWillUnmount = function () {
        this.isCurrentlyMounted = false;
        unbind(this.handleClickAway);
    };
    OutsideClick.prototype.render = function () {
        return this.props.children;
    };
    OutsideClick.propTypes = {
        children: PropTypes.element,
        onOutsideClick: PropTypes.func
    };
    return OutsideClick;
}(React.Component));
exports.OutsideClick = OutsideClick;